import tiersJson from "./data/sourceTiers.json";

/**
 * Non-partisan source-reputation tiers. These describe WHO is reporting (a wire service, a major
 * outlet, a regional paper, a specialist publication, a state-affiliated outlet), never political
 * lean. Part of the "Whole Picture" trust layer: it gives the reader context on the sourcing
 * without InSnip playing referee. Unmapped domains return "source" (a neutral label / no chip).
 */
export type SourceTier = "wire" | "major" | "regional" | "specialist" | "state" | "source";

// The JSON carries a leading "_note" key for documentation; everything else is domain -> tier.
const MAP = tiersJson as Record<string, string>;

const LABELS: Record<SourceTier, string> = {
  wire: "Wire",
  major: "Major",
  regional: "Regional",
  specialist: "Specialist",
  state: "State-affiliated",
  source: "Source",
};

/** Resolve a domain to its tier, walking up subdomains (e.g. science.nasa.gov -> nasa.gov). */
export function tierForDomain(domain: string): SourceTier {
  if (!domain) return "source";
  const clean = domain.replace(/^www\./i, "").toLowerCase();
  if (MAP[clean]) return MAP[clean] as SourceTier;
  const parts = clean.split(".");
  while (parts.length > 2) {
    parts.shift();
    const parent = parts.join(".");
    if (MAP[parent]) return MAP[parent] as SourceTier;
  }
  return "source";
}

export function tierLabel(tier: SourceTier): string {
  return LABELS[tier];
}

/** Whether a tier is meaningful enough to surface a chip (we don't chip the neutral default). */
export function tierHasChip(tier: SourceTier): boolean {
  return tier !== "source";
}
